import React, { useState, useEffect } from "react";

export interface NodeSequenceProps {
  nodes: React.ReactNode[];
  timeout?: number;
  className?: string;
}

export default function NodeSequence({
  nodes,
  timeout = 2000,
  className = "",
}: NodeSequenceProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (nodes.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;
        // Stop at the last node
        return nextIndex >= nodes.length ? nodes.length - 1 : nextIndex;
      });
    }, timeout);

    return () => clearInterval(interval);
  }, [nodes.length, timeout]);

  if (nodes.length === 0) return null;

  return <div className={className}>{nodes[currentIndex]}</div>;
}
